import React, { useState } from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import DefaultModal from 'components/Utils/DefaultModal';
import DefaultTextField from 'components/Utils/DefaultTextField';
import PropTypes from 'prop-types';

const DEFAULT_AUTH = { username: '', password: '' };

const ConfirmAuthenticationDialog = (props) => {
  let [auth, setAuth] = useState(DEFAULT_AUTH);

  function onSubmit() {
    return props.onSubmit(auth);
  }

  return (
    props.isOpen && (
      <DefaultModal
        className="modal authentication-modal"
        wrap={true}
        padding={true}
        title="Authentication"
        content={
          <form style={{ textAlign: 'center' }} onSubmit={onSubmit}>
            <DefaultTextField
              name="Username"
              label="Username"
              value={auth.username}
              onChange={(event) => setAuth({ ...auth, username: event.target.value })}
            />
            <DefaultTextField
              name="Password"
              label="Password"
              type="password"
              value={auth.password}
              onChange={(event) => setAuth({ ...auth, password: event.target.value })}
            />
            <DefaultButton name={props.submitTitle} style={{ width: '250px' }} onClick={onSubmit} />
          </form>
        }
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
      />
    )
  );
};

ConfirmAuthenticationDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitTitle: PropTypes.string.isRequired,
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default ConfirmAuthenticationDialog;
